import { FC, useState } from 'react';

import { Box } from '@mui/material';

import { UnitAccordion } from './UnitAccordion';
import { UnitItem } from './UnitItem';

type ExpandedAccordion = {
  scheduled: string | null;
  waiting: string | null;
  'on-duty': string | null;
  standby: string | null;
};

const AvailableUnits: FC = () => {
  const [expandedPanel, setExpandedPanel] = useState<ExpandedAccordion>({
    waiting: null,
    scheduled: null,
    'on-duty': 'on-duty',
    standby: null,
  });

  const handleExpand = (panel: string, accordion: keyof ExpandedAccordion) => {
    if (expandedPanel[accordion] !== null) {
      setExpandedPanel((prev) => ({ ...prev, [panel]: null }));
    } else setExpandedPanel((prev) => ({ ...prev, [panel]: panel }));
  };

  const unitNames = [
    'AMB100',
    'AMB101',
    'AMB102',
    'AMB103',
    'AMB104',
    'AMB105',
    'AMB106',
    'AMB107',
    'AMB108',
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <UnitAccordion
        title="On duty"
        value="on-duty"
        badge={9}
        currentValue={expandedPanel['on-duty']}
        handleExpand={(p) => handleExpand(p, 'on-duty')}
      >
        {unitNames.map((name) => (
          <UnitItem key={name} name={name} />
        ))}
      </UnitAccordion>
    </Box>
  );
};

export default AvailableUnits;
